import { render, staticRenderFns } from "./physical-volume-dialog.vue?vue&type=template&id=d5ac5cec&lang=pug&"
import script from "./physical-volume-dialog.vue?vue&type=script&lang=ts&"
export * from "./physical-volume-dialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports